import { render, staticRenderFns } from "./TechStav2.vue?vue&type=template&id=0e5152d6&"
import script from "./TechStav2.vue?vue&type=script&lang=ts&"
export * from "./TechStav2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports